<template>
  <div class="flex flex-center q-pa-xl">
    <q-card class="text-center q-pa-lg" flat bordered>
      <q-card-section class="q-gutter-md">
        <q-icon name="mail_outline" size="4rem" color="accent" class="q-mb-md" />
        <div class="text-h4 q-mb-md text-weight-medium">Work Email Required</div>
        <p class="text-body1 text-grey-7 q-mb-lg" style="max-width: 400px; margin: 0 auto">
          Please use your work email account to register. Personal email addresses (such as Gmail,
          Yahoo, or Outlook) are not supported for new accounts.
        </p>
        <div class="q-gutter-sm">
          <q-btn no-caps unelevated color="primary" size="md" @click="leave" class="q-px-lg">
            Log in with Work Email
          </q-btn>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script lang="ts">
export default {
  name: 'WorkEmailRequiredView',
  methods: {
    leave() {
      // Without returnTo, Auth0 uses the tenant default (www.hellodata.ai). Send them back
      // to the app origin instead; authBeforeEnter will start Universal Login.
      this.$auth0.logout({
        logoutParams: {
          federated: true,
          returnTo: window.location.origin
        }
      })
    }
  }
}
</script>
